import { Injectable } from '@angular/core';
import { CropMetricsModel } from './../_models/cropMetrics';

@Injectable()
export class XdataUtilsService {
  cropMetrics: Array<CropMetricsModel> = [];
  allMetrics: Array<CropMetricsModel> = [];
  ghostCropMetricsFilteredYear: Array<CropMetricsModel> = [];
  totalFarm: any;
  totalFarmSizeUnit: any;
  equimentId: any;
  returnInMaintenance: boolean;
  constructor() {}

  getEquipmentId() {
    return this.equimentId;
  }

  getStateOfManteinance() {
    ////  console.log(this.returnInMaintenance);
    return this.returnInMaintenance;
  }
}
